// Movie API routes
const GENRES = 'onboarding/genres/movie'
const SPORTS = `onboarding/genres/sport`
const PROVIDERS = 'onboarding/providers'

export { GENRES, SPORTS, PROVIDERS }
